<div class="glxy-avatar-group-wrapper">
  <ng-container *ngFor="let avatar of shownAvatars; first as isFirst">
    <glxy-avatar
      [src]="avatar.src"
      [width]="avatarWidth"
      [name]="avatar.name"
      [matTooltip]="avatar.name"
      [class.clickable]="avatar.onClick"
      (click)="avatar.onClick ? avatar.onClick() : null"
      [style.margin-left]="isFirst ? null : (avatarWidth / 4) * -1 + 'px'"
    ></glxy-avatar>
  </ng-container>

  <ng-container *ngIf="hasExtraAvatars">
    <div
      class="extra-avatar-counter"
      [style.width]="avatarWidth + 'px'"
      [style.height]="avatarWidth + 'px'"
      [style.font-size]="avatarWidth + 'px'"
      [style.margin-left]="(avatarWidth / 4) * -1 + 'px'"
      [matMenuTriggerFor]="menu"
    >
      <span class="count">+{{ extraAvatars.length }}</span>
    </div>

    <mat-menu #menu="matMenu" class="glxy-avatar-group-menu">
      <ng-container *ngFor="let avatar of extraAvatars">
        <button mat-menu-item [class.clickable]="avatar.onClick" (click)="avatar.onClick ? avatar.onClick() : null">
          <div class="glxy-avatar-group-menu-item">
            <glxy-avatar [src]="avatar.src" [width]="32" [name]="avatar.name"></glxy-avatar>
            {{ avatar.name }}
          </div>
        </button>
      </ng-container>
    </mat-menu>
  </ng-container>
</div>
